const AppView = require('./views/AppView')

const AppRouter = Backbone.Router.extend({

    routes: {
        // Define some URL routes
        '(/)'                                     : 'home',

        
        // Pages
        ':page(/:slug1)(/:slug2)(/:slug3)(/:slug4)(/:slug5)(/:slug6)(/)'       : 'page',

        // Search
        // 'search/(:q)(/)'                            : 'search',
        
        // Default
        '*actions'                                  : 'defaultAction'
    },

    // initialize: function( options ) {

    //     this.viewManager = options.viewManager;

    //     //this.routesHit = 0;
    //     return Backbone.history.on('route', function(e) {
            
    //         Site.routesHit++;
    //         console.log('router: ' + Site.routesHit)
    //         // var matches = Backbone.history.fragment.match('search/(.+)/?');
            
    //         // if ( matches != null && matches.length > 1) {
    //         //     ga('send', 'pageview', '?s=' + matches[1] );
    //         // } else {
    //         //     ga('send', 'pageview', '/' + Backbone.history.fragment );
    //         // }
    //         //if (_gaq) {
    //             //  return _gaq.push(["_trackPageview", "/" + Backbone.history.fragment]);
    //         //}
    //     }, this);
    // },

    stopZombies: function(objView){
        if(typeof objView === "object")
        {
            // alert(1);
            objView.undelegateEvents();
            objView.unbind();
            // $(objView.el).empty();
        }
    }
});

function ViewManager(){

    this.run = function (view) {
        if (this.currentView){
            this.currentView.close();
        }

        this.currentView = view;
        this.currentView.render();
    }
};

export const Router = {
    
    // var initialize = function(){
    initialize: function(){

        // Backbone.history.on('route', function(e) {
        
        // });

        var app_router = new AppRouter({
            viewManager: new ViewManager()
        });
    
       
        !Site.debug || console.log('appView render');
        // console.log(AppView)
        window.app_view = new AppView();
        //app.initialize();
        app_view.render();

        // Home
        app_router.on('route:home', function(){
            !Site.debug || console.log('route:: home');
            var _this = this;
            Site.routesHit++;
            this.stopZombies(this.lastView);
            const PageView = require('./views/page/DefaultView');
            const pageView = new PageView();
            pageView.render({'page': 'home'});
            _this.lastView = pageView;

            // let ls = localStorage.visited.split('|')
            // // console.log(ls)
            // let new_route = 'home/null'
            // if ( ls[0] == new_route ) {
            //     window.back = true
            // } else {
            //     window.back = false
            // }
            // let visited = [ ls[ls.length - 1] ]
            // if ( ls[ls.length - 1] != new_route )
            // {
            //     visited.push(new_route)
            //     localStorage.visited = visited.join('|')
            // }
            // console.log(localStorage)
        
        });

        // Whatson
        app_router.on('route:whatson', function( ...term ){
            // console.log(term)
            !Site.debug || console.log('route:: whatson overview', term);
                        
            
            let _this = this,
                wView = new WhatsonView(),
                url = Backbone.history.fragment,
                checkDropin = /\/london/i,
                matchDropin = checkDropin.exec(url),
                checkFO = /\/membersonly/i,
                matchFriendsOnly = checkFO.exec(url),
                subpage = '',
                
                filterObject = {
                    london: matchDropin != null && matchDropin.length > 0,
                    membersonly: matchFriendsOnly != null && matchFriendsOnly.length > 0,
                }
            
            _this.stopZombies( _this.lastView );

            if ( term[0] == 'london' || term[0] == 'membersonly' ) {
                subpage = term[1];
            } else {
                subpage = term[0];
            }
            
            console.log(subpage)

            if ( term[0] == 'events-and-workshops') {
                filterObject.types = {
                    0: 'backstage-event', 
                    1: 'workshop', 
                    2: 'rehearsal', 
                    3: 'performance'
                };
            }
            if ( term[0] == 'ballet-classes')
            {
                filterObject.types = {
                    0: 'ballet-classes'
                };
            }

            wView.render( subpage, filterObject );
            _this.lastView = wView;    
            
            
        });


        // Page
        app_router.on('route:page', function(page, subpage){
            !Site.debug || console.log('route:: general page', page, subpage);
            var _this = this;
            Site.routesHit++;
            this.stopZombies(this.lastView);
            // requirejs(['views/page/DefaultView'], function(PageView){
            var PageView = require('./views/page/DefaultView');
            var pageView = new PageView();
            pageView.render({
                    'page': page, 
                    'subpage': subpage 
                });
            _this.lastView = pageView;    
            // });
            // window.visited.push(page + '/' + subpage)
            // console.log(window.visited)
            // let ls = localStorage.visited.split('|')
            // // console.log(ls)
            // let new_route = page + '/' + subpage
            // if ( ls[0] == new_route ) {
            //     window.back = true
            // } else {
            //     window.back = false
            // }
            // let visited = [ ls[ls.length - 1] ]
            // if ( ls[ls.length - 1] != new_route )
            // {
            //     visited.push(new_route)
            //     localStorage.visited = visited.join('|')
            // }
            // console.log(localStorage)
            // console.log(localStorage.visited.split('|'))
        });

        

        // Search
        // app_router.on('route:search', function(q){
        //     !Site.debug || console.log('route:: search', q);
        //     this.stopZombies(this.lastView);
        //     var _this = this;
        //     require(['views/page/SearchView'], function(SearchView){
        //         searchView = new SearchView();
        //         searchView.render();
        //         _this.lastView = searchView;
        //     });
        // });

        
        Backbone.history.start({
                pushState: true, 
                hashChange: false,
                root: Site.root,
                silent: !1
        });

    }


}

// Default export
export default {
  // Some data...

};